<template>
  <div class="NetworkDescription">
    <div class="flexWrapper">
      <div class="logoWrapper">
        <img class="logoImg" :src="networkLogo" :alt="networkName" />
      </div>
      <div class="textWrapper">
        <div class="text" v-html="text"></div>
        <div class="cta">
          <a :href="btnHref" target="_blank" class="logoCta">
            {{btnText}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NetworkDescription',
    data(){
      return {

      }
    },
    components:{
    },
    props: {
      networkLogo: {
        type: String,
        default: ""
      },
      networkName: {
        type: String,
        default: ""
      },
      btnHref: {
        type: String,
        default: ""
      },
      btnText: {
        type: String,
        default: ""
      },
      text: {
        type: String,
        default: "#000"
      }
    },
    computed: {
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .flexWrapper{
    display: flex;
    @media (max-width:  @bootstrap-md - 1px){
      flex-direction: column;
    }
  }
  .logoWrapper{
    margin-right: 90px;
  }

  .textWrapper{
    line-height: 24px;
    font-size: 18px;
    color: #707070;
    a:link, a:visited, a:hover, a:active{
      color: #8A32EA;
      text-decoration: none;
    }
    .text{
      margin-bottom: 30px;
    }

    .cta{
      line-height: 17px;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }
</style>
